import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { SearchFilterValueDto } from './search-filter-value-dto.type';

const AvailableFilterOptionDto = t.type(
  {
    entityType: nullable(t.string),
    name: t.string,
    fieldName: t.string,
    order: nullable(t.number),
    dataType: t.string,
    uiType: t.string,
    values: t.array(SearchFilterValueDto),
  },
  'AvailableFilterOptionDto',
);

type AvailableFilterOptionDto = t.TypeOf<typeof AvailableFilterOptionDto>;
export { AvailableFilterOptionDto };
